/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(initialState: { currentUser?: API.userRes } | undefined) {
  const { currentUser } = initialState ?? {};
  return {
    canAdmin: currentUser?.user_type === 'admin',
  };
}
